// extracted by mini-css-extract-plugin
module.exports = {"when":"style-module_when__3SvqaPrGMtL7VL77Vdm1qb"};